import React, { useEffect, useState } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { faEdit, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';

//Helpers
import { IsValidDate, PrintValidate, objCampo, validarCampos } from '../../helpers/ValidadorDeCampos';
import { showMessage } from '../../helpers/message';
import mascaras from '../../helpers/mascaras';

//Constants
import { actionsTable } from '../../constants/MaterialTable';

//Components
import MainCard from '../../components/MainCard/MainCard';
import Loading from '../../components/Loading/Loading';
import TextField from '../../components/TextField/TextField';
import TabelaListagem from '../../components/TabelaListagem/TabelaListagem';
import ModalCustomized from '../../components/Modal/Modal';

//API
import modalidadeColeta_api from '../../api/modalidadeColeta_api';
import manejoResiduo_api from '../../api/manejoResiduo_api';

//Context
import { useAuth } from 'context/auth';


function initialStateFiltros() {
    return {
        dataInicial: moment(new Date()).format("YYYY-MM-DD"),
        dataFinal: moment(new Date()).format("YYYY-MM-DD"),
    }
}

function initialStateManejoResiduo() {
    return {
        tbTipoColeta_Id: "",
        peso: "",
        tipoManejo: "",
        tbUsuarios_Id: null,
        tbDestinos_Id: null
    }
}

export default function ManejoResiduos() {
    const { session } = useAuth();

    //Estado de controle dos valores dos filtros
    const [filtros, setFiltros] = useState(initialStateFiltros());

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle de visualização da ficha
    const [manejoResiduo, setManejoResiduo] = useState(initialStateManejoResiduo());

    //Estado para manipular modal
    const [modalidades, setModalidades] = useState([]);

    //Estado para desabilitar campos
    const [disabledCampos, setDisabledCampos] = useState(false);

    //Estado para pegar a lista
    const [listManejoResiduos, setListManejoResiduos] = useState([]);

    //Estado para controlar modal
    const [openModal, setOpenModal] = useState(false);

    const toggleModal = () => setOpenModal(!openModal);

    //Estado de controle dos errors
    const [errorsManejoResiduo, setErrorsManejoResiduo] = useState({});

    //Estado de controle dos errors
    const [errors, setErrors] = useState({});

    //Cabeçalhos da tabela
    const headers = [
        { value: "Data Registro", objectValue: "dataFormatada" },
        { value: "Modalidade de coleta", objectValue: "modalidade", align: "left" },
        { value: `Tipo de Manejo`, objectValue: "tipoManejo", align: "right" },
        { value: "Peso", objectValue: "peso", align: "left" }
    ];

    //campos obrigatorios dos filtros
    const camposManejoResiduo = [
        objCampo({ name: "tbTipoColeta_Id", required: true }),
        objCampo({ name: "peso", required: true }),
        objCampo({ name: "tipoManejo", required: true }),
    ];

    //Opções do select de status
    const statusOptions = [
        { label: "Aterro", value: "Aterro" },
        { label: "Incineração", value: "Incineração" },
        { label: "Reciclagem", value: "Reciclagem" },
    ]

    const onClickRemover = (item) => {
        setLoading(true);
        manejoResiduo_api.DeleteManejoResiduo(item.id)
            .then(_ => showMessage("Sucesso", "Registro excluído com sucesso.", "success", () => {
                loadManejoResiduos(filtros);
                setManejoResiduo(initialStateManejoResiduo());
            }))
            .catch(e => { showMessage("Aviso", e.message, "error", null); })
            .finally(() => setLoading(false))
    }

    //Carrega as modalidades de coleta do filtro
    const loadModalidades = () => {
        setLoading(true)
        modalidadeColeta_api.GetList().then(response => {
            response.data = response.data.map(value => { return { label: value.descricao, value: value.id.toString() } })
            setModalidades(response.data);
        })
            .catch(e => { showMessage("Aviso", e.message, "error", null); })
            .finally(() => setLoading(false))
    }

    const removerItem = (row) => {
        if (new Date(row.dataRegistro).getDate() == new Date().getDate())
            return actionsTable.remover(onClickRemover)
        else
            return null
    }

    //Ações da tabela de listagem das notificações
    const actions = [removerItem];

    //OnChange do campo de cpf cnpj
    const onChangeCampos = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        })
    }

    const loadManejoResiduos = () => {
        if ((!filtros.dataInicial && filtros.dataFinal) || (filtros.dataInicial && !filtros.dataFinal)) {
            setErrors({ ...!filtros.dataInicial ? { dataInicial: { message: "Informe a data inicial" } } : { dataFinal: { message: "Informe a data final" } } });
            return;
        }

        if ((new Date(filtros.dataInicial)).getTime() > (new Date(filtros.dataFinal)).getTime()) {
            setErrors({ dataInicial: { message: "A data inicial não pode ser maior do que a data final" } });
            return;
        }

        setErrors({});

        setLoading(true)
        manejoResiduo_api.GetListManejoResiduo(filtros)
            .then(response => {
                response.data = response.data?.map((value) => {
                    value.tbTipoColeta_Id = value?.tbTipoColeta_Id?.toString();
                    value.peso = value.peso.toFixed(2).replace(".", ",")
                    value.dataFormatada = moment(value.dataRegistro).format("DD/MM/YYYY");
                    return value
                })
                setListManejoResiduos(response.data);
            })
            .catch(e => { showMessage("Aviso", e.message, "error", null); })
            .finally(() => setLoading(false))
    }

    const addManejoResiduo = () => {
        const erros = validarCampos(manejoResiduo, camposManejoResiduo);
        setErrorsManejoResiduo(erros[0]);

        if (erros[1].length > 0) {
            return;
        }

        const _manejoResiduo = { ...manejoResiduo }

        _manejoResiduo.tbUsuarios_Id = session.usuario_Id;
        _manejoResiduo.tbDestinos_Id = session?.acesso?.acesso_id;
        _manejoResiduo.peso = parseFloat(_manejoResiduo.peso.replace(",", "."))

        if (_manejoResiduo?.id) {
            setLoading(true);
            manejoResiduo_api.PutManejoResiduo(_manejoResiduo)
                .then(_ => {
                    showMessage("Sucesso", "Manejo de resíduo atualizado com sucesso.", "success", () => {
                        setManejoResiduo(initialStateManejoResiduo());
                        loadManejoResiduos();
                        toggleModal();
                    })
                })
                .catch(e => { showMessage("Aviso", e.message, "error", null); })
                .finally(() => setLoading(false))
        } else {
            setLoading(true);
            manejoResiduo_api.PostManejoResiduo(_manejoResiduo)
                .then(_ => {
                    showMessage("Sucesso", "Manejo de resíduo cadastrado com sucesso.", "success", () => {
                        setManejoResiduo(initialStateManejoResiduo());
                        loadManejoResiduos();
                        toggleModal();
                    })
                })
                .catch(e => { showMessage("Aviso", e.message, "error", null); })
                .finally(() => setLoading(false))
        }
    }

    //Change para os selects com pesquisa
    const onChangeSearchSelect = (e, select) => {
        const { name } = select;
        setManejoResiduo({ ...manejoResiduo, [name]: e?.value ? e.value : "" })
    }

    const onChange = (e) => {
        const { name, value } = e.target;

        const _manejoResiduo = {
            ...manejoResiduo,
            [name]: value
        }
        const erros = validarCampos(_manejoResiduo, camposManejoResiduo.filter(c => c.name == name));
        if (erros[1].length == 0) {
            const _errors = { ...errorsManejoResiduo };
            delete _errors[name];
            setErrorsManejoResiduo(_errors);
        }

        setManejoResiduo({ ...manejoResiduo, [name]: value })
    }

    useEffect(() => {
        loadModalidades();
        loadManejoResiduos();
    }, []);

    return (
        <MainCard noCard btnCadastro={"Adicionar"}
            onClickBtnCadastro={() => setOpenModal(true)}
        >
            {loading && <Loading />}
            <ModalCustomized
                isOpen={openModal}
                toggle={() => {
                    setManejoResiduo(initialStateManejoResiduo())
                    toggleModal();
                    setDisabledCampos(false);
                }}
                title={manejoResiduo?.id ? <><FontAwesomeIcon icon={faEdit} /> Editar manejo de resíduo</> : "+ Adicionar novo manejo de resíduo"}
                btnAction={manejoResiduo?.id ? <><FontAwesomeIcon icon={faEdit} /> Editar</> : "+ Adicionar"}
                btnActionColor={manejoResiduo?.id ? "warning text-light" : "success"}
                onClickBtnAction={addManejoResiduo}
                btnClose
                disabled={disabledCampos}
            >
                <Row className='mb-3'>
                    <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
                </Row>
                <Row>
                    <Col lg={"4"} md="6" sm="12">
                        <TextField
                            label="Modalidade de coleta"
                            type={"select"}
                            searchable
                            name={"tbTipoColeta_Id"}
                            onChange={onChangeSearchSelect}
                            value={modalidades.filter(x => x.value == manejoResiduo.tbTipoColeta_Id)[0]}
                            options={modalidades}
                            invalid={!!errorsManejoResiduo.tbTipoColeta_Id}
                            disabled={disabledCampos}
                        />
                    </Col>
                    <Col lg={"4"} md="6" sm="12">
                        <TextField
                            label="Tipo Manejo"
                            type={"select"}
                            searchable
                            name={"tipoManejo"}
                            onChange={onChangeSearchSelect}
                            value={statusOptions.filter(x => x.value == manejoResiduo.tipoManejo)[0]}
                            options={statusOptions}
                            invalid={!!errorsManejoResiduo.tipoManejo}
                            disabled={disabledCampos}
                        />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField
                            maxLength={"10"}
                            label={"* Peso"}
                            name={"peso"}
                            value={manejoResiduo.peso}
                            mask={mascaras.floatMask}
                            onChange={onChange}
                            invalid={!!errorsManejoResiduo.peso}
                            disabled={disabledCampos}
                        />
                    </Col>
                </Row>
            </ModalCustomized>
            <Row>
                <Col md="6" lg="4">
                    <TextField
                        label={`Data Inicial`}
                        type={"date"}
                        value={filtros.dataInicial}
                        onChange={onChangeCampos}
                        name={"dataInicial"}
                        maxLength="18"
                        invalid={!!errors.dataInicial}
                    />
                    <PrintValidate field={"dataInicial"} errors={errors} />
                </Col>
                <Col md="6" lg="4">
                    <TextField
                        label={`Data Final`}
                        type={"date"}
                        value={filtros.dataFinal}
                        onChange={onChangeCampos}
                        name={"dataFinal"}
                        maxLength="18"
                        invalid={!!errors.dataFinal}
                    />
                    <PrintValidate field={"dataFinal"} errors={errors} />
                </Col>
                <Col md="6" lg="4" className='mt-2'>
                    <br />
                    <Button
                        onClick={loadManejoResiduos}
                        color='primary'
                    >
                        <FontAwesomeIcon icon={faSearch} /> Pesquisar
                    </Button>
                </Col>
            </Row>
            <TabelaListagem
                title={"Lista manejo de resíduos"}
                items={listManejoResiduos}
                headers={headers}
                actions={actions}
            />
        </MainCard>
    );

}
